import StyledSwitchButton from 'components/Buttons/SwitchButton';
import { SubText, FlexBox } from './SensorAnalysis.styles';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { setDataType, setHighGrainExecute } from 'store/sensorAnalysis.slice';
import { useTranslation } from 'react-i18next';

export const DataTypeToggle = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const dataType = useAppSelector(
    (state) => state.sensorAnalysisReducer.dataType
  );

  const chartType = useAppSelector(
    (state) => state.sensorAnalysisReducer.chartType
  );

  const handleDataTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setDataType(e.target.checked ? 'highGrain' : 'regular'));
    if (e.target.checked) {
      dispatch(setHighGrainExecute(true));
    }
  };

  return (
    <FlexBox sx={{ gap: 0.25, alignItems: 'center' }}>
      <SubText>{t('regular_data')}</SubText>
      <StyledSwitchButton
        checked={dataType === 'highGrain'}
        onChange={handleDataTypeChange}
        disabled={chartType === 'Grouped'}
      />
      <SubText>{t('high_grain_data')}</SubText>
    </FlexBox>
  );
};
